import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';

import { CompressedImage } from 'web-services/Imgix';
import { RoundedSpinner } from 'web-ui-kit/loading';
import { QUERY_FOR_MOBILE_UP } from 'web-ui-kit/media';
import { Box } from 'web-ui-kit/containers';
import { getImage } from 'utils/utils';
import NoImage from './NoImage';

export default function ImageElement ({
  fromAddToCartFeedback = false,
  fromOrderDetails = false,
  fromVariants = false,
  mainImage = false,
  src = ''
}) {
  const [isLoading, setIsLoading] = useState(true);
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    const srcImage = getImage(src);
    srcImage && setImageUrl(srcImage);
  }, []);

  useEffect(() => {
    setIsLoading(true);
    const srcImage = getImage(src);
    srcImage && setImageUrl(srcImage);
  }, [src]);

  const onLoad = () => {
    setIsLoading(false);
  };

  const onError = () => {
    setImageUrl('');
  };

  if (!imageUrl) {
    return <NoImage />;
  }

  /**
   * We currently have 5 different sizes to set for imgix:
   * - main PDP image [238px => 100vw],
   * - thumbnails of the alternative products or variants [112px on mobile => 143px],
   * - thumbnails of the selected product [hidden on mobile => 86 x 86],
   * - thumbnail in the AddToCartFeedback popup [60 x 60],
   * - thumbnails in the OrderDetails [50 x 50 => 112 x 112]
   */
  const getImgixSizes = () => {
    switch (true) {
      case mainImage:
        return `${QUERY_FOR_MOBILE_UP} 100vw, 238px`;
      case fromVariants:
        return `${QUERY_FOR_MOBILE_UP} 143px, 112px`;
      case fromOrderDetails:
        return `${QUERY_FOR_MOBILE_UP} 112px, 50px`;
      default:
        return undefined;
    }
  };

  const getImgixHeightAndWidth = () => {
    switch (true) {
      case fromAddToCartFeedback:
        return 60;
      case (!mainImage && !fromVariants && !fromOrderDetails):
        return 86;
      default:
        return undefined;
    }
  };

  const sizes = getImgixSizes();
  const height = getImgixHeightAndWidth();
  const width = getImgixHeightAndWidth();

  return (
    <Box>
      {isLoading &&
        <Spinner delay={500} />
      }

      <CompressedImageElement
        alt='compressed-image-element'
        className={!isLoading && 'active'}
        onError={onError}
        onLoad={onLoad}

        bucketName='modsy'
        src={imageUrl}
        sizes={sizes}

        height={height}
        width={width}
      />
    </Box>
  );
}

// Styles
const Spinner = styled(RoundedSpinner)`
  position: absolute;
  top: 50%;
  right: 50%;
  margin-right: -20px;
  margin-top: -20px;
`;

const CompressedImageElement = styled(CompressedImage)`
  position: absolute;
  top: 50%;
  left: 50%;

  object-fit: contain;
  max-height: 100%;
  max-width: 100%;

  opacity: 0;
  transform: translate(-50%, -50%);

  &.active {
    opacity: 1;
  }
`;
